import React from "react";
import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ArtGallery from "../images/art-gallery.jpg"; // Import your artist image
import WildWoman from "../images/wild-woman.jpg";
import WomanSquares from "../images/woman-squares.jpg";
import MarshFog from "../images/MarshFog.jpeg";
import Splash from "../components/Splash";

const Home = ({ user }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const hiddenElements = document.querySelectorAll(".slideUp");
    console.log("hidden elements", hiddenElements);

    const observerOptions = {
      root: null, // using the viewport as the root
      threshold: 0.2, // trigger when 50% of the target is visible
      rootMargin: "0px", // adjust this value to fine-tune when the observer triggers
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log("HomeShow", entry);
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    }, observerOptions);

    hiddenElements.forEach((el) => observer.observe(el));

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []); // Empty dependency array to run only on mount

  return (
    <>
      <Splash className='slideUp' />
      <Container id='targetSection' className='mt-3'>
        <Row className='mt-3 d-flex align-items-center'>
          <h1 className='whiteText'>Welcome</h1>
          <Col lg={{ span: 6, order: 1 }} className='whiteText slideUp'>
            <p>
              Exciting news! The Piermont Flywheel Gallery is back with two
              thrilling Guest Artist Showcases. These two 4-week shows are your
              chance to showcase your talent. The first runs from January 11 to
              February 4, followed by the second from February 8 to March 3.
            </p>
            <p>
              But there's more! We're committed to promoting your work. Our
              expert team will assist you in organizing your exhibit, and we'll
              also help you host a fantastic reception to celebrate your
              artistry. Join us for a triumphant return!
            </p>
          </Col>
          <Col lg={{ span: 6, order: 2 }} className='text-center slideUp'>
            <img src={ArtGallery} alt='Artist Showcase' className='img-fluid' />
          </Col>
        </Row>

        <Row className='mt-3 d-flex align-items-center'>
          <Col
            // md={{ span: 12, order: 2 }}
            lg={{ span: 6, order: 1 }}
            className='text-center slideUp'>
            {/* <Col lg={6} sm={{ order: 2 }} className='text-center'> */}
            <img src={WildWoman} alt='Artist Showcase' className='img-fluid' />
          </Col>
          <Col
            md={{ span: 12, order: 1 }}
            lg={{ span: 6, order: 2 }}
            className='whiteText mt-4 slideUp'>
            {/* <Col lg={6} sm={{ order: 1 }} className='whiteText mt-4'> */}
            <h2>Grow as an Artist - Sell Your Work</h2>
            <p>
              Elevate your artistry with our Showcase! You have control over
              your prices and keep 100% of your individual sales (minus credit
              card fees if applicable). No application fee! If selected, the
              one-time fee is just $400.
            </p>
            <p>
              Participating artists will take turns gallery sitting during their
              show, ensuring equal participation.
            </p>
            <p>
              We welcome all art forms and mediums, from classic paintings to
              innovative digital installations, fine art photography, mixed
              media, and three-dimensional artworks (sculpture, pottery, etc.).
            </p>
          </Col>
        </Row>

        <Row className='mt3 d-flex align-items-center'>
          <Col lg={{ span: 6, order: 1 }} className='whiteText mt-4 slideUp'>
            <h2>Take the Next Steps</h2>
            <p>Here's what we'll need:</p>
            <ul className='mt-2'>
              <li>Your full name, email and mobile phone</li>
              <li>Social media links or website showcasing your work</li>
              <li>
                A short Biography or artist's statement in about 100 words.
                Include a little about yourself, how long you've been an artist,
                what medium do you use, what inspires you, recent exhibits,
                education and training, why you like to make art.
              </li>
            </ul>
            <p>
              Need a little help writing your bio? We have an AI powered
              BioWriter to help you out! You can upload up to 7 samples of your
              work. Please keep the file less than 2 MB.
            </p>
          </Col>

          <Col lg={{ span: 6, order: 2 }} className='text-center slideUp'>
            <img
              src={WomanSquares}
              alt='Artist Showcase'
              className='img-fluid'
            />
          </Col>
        </Row>

        <Row className='mt3 d-flex align-items-center'>
          <Col
            md={{ span: 12, order: 2 }}
            lg={{ span: 6, order: 1 }}
            className='text-center slideUp'>
            <img src={MarshFog} alt='Artist Showcase' className='img-fluid' />
          </Col>
          <Col
            md={{ span: 12, order: 1 }}
            lg={{ span: 6, order: 2 }}
            className='whiteText mt-4 slideUp'>
            <h2>Don't Miss Out</h2>
            <p>
              The deadline for submissions will be announced shortly. Once the
              finalists are selected, we'll reach out to you directly with all
              the details leading up to your show.
            </p>
            <p>
              Our jury of gallery member artists will select works based on
              quality of work, medium, size and the number of participating
              artists. Each featured artist will have equal space in our
              gallery.
            </p>
            {!user && (
              <p>
                It's easy to get started! Be sure to read and accept our terms
                and conditions document after you register.
              </p>
            )}
            {!user && (
              <p>
                We can't wait to see your incredible art grace our gallery! Get
                those submissions in, and let's create two shows to remember.
                🎨✨
              </p>
            )}{" "}
            {!user && (
              <Button
                className='btn btn-primary mb-4'
                onClick={() => navigate("/Register")}>
                Register to Get Started
              </Button>
            )}
          </Col>
        </Row>

        <Row className='mt-3 d-flex align-items-left'>
          <Col lg={4} className='whiteText'></Col>
          <Col lg={4} className='whiteText'>
            {" "}
          </Col>
          <Col lg={4} className='whiteText'>
            {" "}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;
